module.exports = __webpack_public_path__ + "static/media/chatbot.d3552479.png";